<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" scrollable width="80%" persistent>
      <v-card>
        <v-card-title class="grey lighten-4 pa-1 pl-2">
          <h3 class="secondary--text">Analytics</h3>
        </v-card-title>
        <v-divider></v-divider>
        <div v-if="analyticsSessions && analyticsSessions.length">
          <v-layout row wrap>
            <v-flex xs6 class="pa-2">
              <v-layout row wrap>
                <v-flex xs12>
                  <div class="headline secondary--text">
                    <span>Movie : {{ film.title }}</span>
                  </div>
                  <span class="subheading greyDarken1--text"
                    >Total Sessions : {{ analyticsSessions.length }}</span
                  >
                  <div>
                    <span class="subheading greyDarken1--text"
                      >Consumer :
                      {{
                        consumer.name
                          ? consumer.name + `( ${consumer.email} )`
                          : consumer.email
                      }}</span
                    >
                  </div>
                </v-flex>
                <v-flex
                  v-if="analyticsSessions && analyticsSessions.length"
                  xs12
                  class="pt-3"
                >
                  <v-card-title class="grey lighten-4 pa-1 pl-2">
                    <h3 class="secondary--text">Select Session</h3>
                  </v-card-title>
                  <div class="text-xs-left pt-2 pa-1">
                    <v-btn-toggle v-model="currentSession">
                      <v-btn
                        v-for="(session, index) in analyticsSessions"
                        :key="session"
                        flat
                        :value="session"
                      >
                        {{ "S" }}{{ index + 1 }}
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                </v-flex>
                <!-- Loader -->
                <v-flex v-if="loading" xs12>
                  <div class="text-xs-center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    ></v-progress-circular>
                  </div>
                </v-flex>
                <v-flex v-else-if="currentSession" xs12 class="pt-5 mt-5">
                  <v-card-title class="grey lighten-4 pa-1 pl-2">
                    <h3 class="secondary--text">Current Session</h3>
                  </v-card-title>

                  <v-layout v-if="currentSession" row wrap>
                    <v-flex xs12 class="pa-2">
                      <span class="subheading greyDarken1--text">
                        Session : {{ indexOfSession(currentSession) + 1 }}</span
                      >
                      <div>
                        <span class="subheading greyDarken1--text"
                          >Session start at :
                          {{ analytics[currentSession][0].timestamp }}</span
                        >
                      </div>
                      <div>
                        <span class="subheading greyDarken1--text"
                          >Session start at :
                          {{
                            analytics[currentSession][
                              analytics[currentSession].length - 1
                            ].timestamp
                          }}</span
                        >
                      </div>
                      <div v-if="totalWatchedMinutes">
                        <span class="subheading greyDarken1--text"
                          >Watched minutes : {{ totalWatchedMinutes }}</span
                        >
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6 class="pa-2" style="border-left: 1px solid #cfd2cf">
              <v-layout row wrap>
                <v-flex xs12 class="pt-3 pl-2">
                  <div v-if="streamingUrl" class="text-xs-center">
                    <AnalyticsPlayer
                      ref="analyticsPlayer"
                      :movie="streamingUrl"
                    ></AnalyticsPlayer>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <div
            v-if="playingLength == '00:00' && !timelineActivity.length"
            class="text-xs-center pa-2 subheading greyDarken1--text"
          >
            Select any session to continue
          </div>
          <div v-else class="text-xs-center pa-2 headline greyDarken1--text">
            {{ playingLength }}
          </div>
          <div v-if="loading" class="text-xs-center pa-5">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <div class="videoTimeline"></div>
        </div>
        <div v-else class="text-xs-center pa-5">
          Analytics are not available for this consumer
        </div>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="blue darken-1" flat @click="$emit('onClose')"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import AnalyticsPlayer from "@/components/screener/AnalyticsPlayer";

export default {
  name: "ConsumerFilmAnalytics",
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    consumer: {
      type: Object,
      default: null,
    },
    analytics: {
      type: Object,
      default: null,
    },
    film: {
      type: Object,
      default: null,
    },
  },
  components: {
    AnalyticsPlayer,
  },
  data() {
    return {
      dialogm1: "",
      currentSession: null,
      streamingUrl: null,
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
        rowsPerPage: 10,
      },
      loading: false,
      timelineActivity: [],
      headers: [
        {
          text: "Watched Seconds",
          align: "left",
          sortable: false,
          value: "watched_seconds",
        },
        {
          text: "Play length",
          align: "left",
          sortable: false,
          value: "play_length",
        },
        {
          text: "Country code",
          align: "left",
          sortable: false,
          value: "country_code",
        },
        { text: "time", align: "left", sortable: false, value: "timestamp" },
      ],
      totalWatchedMinutes: 0,
      todos: [
        { text: "Learn JavaScript", done: false },
        { text: "Learn Vue", done: false },
        { text: "Play around in JSFiddle", done: false },
        { text: "Build something awesome", done: false },
      ],
      playingLength: "00:00",
    };
  },
  mounted() {
    this.getStreamingUrlOfFilm();
  },
  watch: {
    currentSession: {
      handler: function (newSession, oldSession) {
        this.calculateTimelineActivity(newSession);
      },
    },
  },
  computed: {
    analyticsSessions() {
      const sessions = Object.keys(this.analytics);
      // this.currentSession = sessions[0];
      return sessions;
    },
    videoLength() {
      if (!this.streamingUrl) return 0;

      let video = document.getElementById("video");
      if (video && video.readyState) {
        return parseInt(video.duration);
      }

      return 0;
    },
    // timelineActivity() {
    //   console.log('Triggered --.')
    //   if((!this.currentSession) || (!this.videoLength)) return null;

    //   this.loading = true
    //   let timeline = Array(503).fill(0);
    //   this.analytics[this.currentSession].forEach(event => {
    //     for (let index = 1; index <=event.round_of_watch_seconds; index++) {
    //       timeline[event.round_of_play_length - index]+=1;
    //     }
    //   });
    //   this.loading = false;
    //   return timeline
    // }
  },
  methods: {
    async getStreamingUrlOfFilm() {
      await this.$store
        .dispatch("film/getStreamingUrl", {
          film_id: this.film.id,
        })
        .then((res) => {
          this.streamingUrl = res.streaming_url;
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
          this.streamingUrl = null;
        });
    },

    indexOfSession(session) {
      return this.analyticsSessions.indexOf(session);
    },

    calculateTimelineActivity(session) {
      let watchedSeconds = 0;
      // if((!this.currentSession) || (!this.videoLength)) return null;
      this.loading = true;
      let timeline = Array(this.videoLength).fill(0);
      this.analytics[session].forEach((event) => {
        watchedSeconds =
          parseInt(event.round_of_watch_seconds) + parseInt(watchedSeconds);
        for (let index = 1; index <= event.round_of_watch_seconds; index++) {
          timeline[event.round_of_play_length - index] += 1;
        }
      });

      this.totalWatchedMinutes = (watchedSeconds / 60).toFixed(2);
      this.loading = false;
      this.timelineActivity = timeline;
      this.plotSVG(timeline);
    },

    plotSVG(timelineActivity) {
      const _this = this;
      d3.select("#videoTimelineSVG").remove();

      //Prepare SVG Base
      const svg = d3
        .select(".videoTimeline")
        .append("svg")
        .attr("id", "videoTimelineSVG")
        .attr("width", this.videoLength)
        .attr("height", "100%");

      const lines = svg
        .selectAll("line")
        .data(timelineActivity)
        .enter()
        .append("line")
        .style("stroke-width", 2)
        .attr("x1", (d, index) => index)
        .attr("y1", 0)
        .attr("x2", (d, index) => index)
        .attr("y2", 150)
        .style("stroke", (d) => (d ? "powderblue" : "darkgray"))
        .on("mouseover", function (e, d) {
          d3.select(this).style("stroke", "black");
          _this.showMessage(d, lines.nodes().indexOf(this));
        })
        .on("mouseout", function (e, d) {
          d3.select(this).style("stroke", (d) =>
            d ? "powderblue" : "darkgray"
          );
        })
        .on("click", function (d, i) {
          _this.seekTo(lines.nodes().indexOf(this));
        });
    },

    seekTo(second) {
      let video = document.getElementById("video");
      if (!video) return;

      video.currentTime = second;
    },

    convertToMinutes(totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
      const seconds = totalSeconds - hours * 3600 - minutes * 60;
      if (hours) {
        return `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      }
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    },
    showMessage(data, second) {
      this.playingLength = this.convertToMinutes(second);
    },
  },
};
</script>
<style scoped>
.videoTimeline {
  height: 150px;
  width: 100%;
  overflow: auto;

}
/* #videoTimelineSVG {
  overflow: initial;
} */

.timelineCell {
  height: 100%;
  display: inline-block;
  width: 1px;
}

.activeTimeline {
  fill: aqua;
}

.inActiveTimeline {
  fill: darkgray;
}
</style>
